import React, {useState} from 'react'
import {Button, Form, Modal, AutoComplete} from "antd";
import {EditOutlined} from "@ant-design/icons";
import {completedShippingOrder, waitingShippingOrder} from "../../../services/serviceWarehouseOutgoing";
import {enterLoadingState, exitLoadingState} from "../../../utils/helpers/commonFunctions";

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}


const OutgoingShippingEdit = ({record, updater}) => {
    const [form] = Form.useForm()
    const [editModal, setEditModal] = useState(false)
    const [loadings, setLoadings] = useState([])


    const handleEditClick = () => {
        setEditModal(!editModal)
    }

    const autoCompleteOptions = [
        {
            value: 'Bekliyor',
        },
        {
            value: 'Tamamlandı',
        }
    ]

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            statusComplete: 'COMPLETED'
        }

        if (list.statusComplete === 'Bekliyor'){
            requestObj.statusComplete = 'WAITING'
        }

        if (requestObj.statusComplete === 'COMPLETED'){
            completedShippingOrder(record.id)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setEditModal(!editModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))
        }else{
            waitingShippingOrder(record.id)
                .then(() => {
                    exitLoadingState(setLoadings)
                    setEditModal(!editModal)
                    updater()
                })
                .catch(() => exitLoadingState(setLoadings))


        }

    }

    return(
        <React.Fragment>
            <Button  className={'btn-edit'} onClick={()=>handleEditClick()}><EditOutlined /></Button>
            <Modal
                open={editModal}
                onCancel={() => setEditModal(!editModal)}
                title={'Güncelle'}
                footer={[
                    <Button type={'primary'} key={'SubmitButton'}
                            loading={loadings[0]}
                            onClick={()=>handleSubmit(form.getFieldsValue())}>Kaydet</Button>,
                    <Button onClick={() => setEditModal(!editModal)} key={'CloseButton'} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Sevk Durumu'}
                        name={'statusComplete'}
                    >
                        <AutoComplete
                            options={autoCompleteOptions}
                        >

                        </AutoComplete>

                    </Form.Item>
                </Form>

            </Modal>
        </React.Fragment>
    )
}
export default OutgoingShippingEdit